/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../../client/js/components/NoData'
import SelectionToggle from '../../../../client/js/components/selection/SelectionToggle'
import EstateListItem from './EstateListItem'

export type EstateListProps = {
  items: Estate[]
}

function EstateList (props: EstateListProps) {
  const { items } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={50}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th w={120}>
            <FormattedMessage
              id="state"
              defaultMessage="État"
            />
          </Table.Th>
          <Table.Th w={200}>
            <FormattedMessage
              id="photo"
              defaultMessage="Photo"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="reference"
              defaultMessage="Référence"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="title"
              defaultMessage="Titre"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="city"
              defaultMessage="Ville"
            />
          </Table.Th>
          <Table.Th w={120} ta="end">
            <FormattedMessage
              id="price"
              defaultMessage="Prix"
            />
            &nbsp;/&nbsp;
            <FormattedMessage
              id="rent"
              defaultMessage="Loyer"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="owner"
              defaultMessage="Propriétaire"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <EstateListItem
              item={item}
              key={item.id}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={10}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default EstateList
